import DoNotDisturbIcon from "@mui/icons-material/DoNotDisturb";
import {
  Box,
  Button,
  FormControl,
  IconButton,
  InputLabel,
  MenuItem,
  Select,
  Typography,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import React from "react";
import {
  adminButtonOutlinedSx,
  adminButtonPrimarySx,
} from "../../../../../components/AdminDashboard/modalStyle";
import { updateBlock } from "../../../../../services/expositor.service";
import { ModalComponent } from "../../../../../ui-components/Modal";
import { useToast } from "../../../../../ui-components/ToastProvider";

interface Expositor {
  name: string;
  email: string;
  created_at: Date;
  is_admin: boolean;
  full_address: string;
  instagram_url: string;
  brand_name: string;
  address: string;
  id: number;
  phone: string;
  brand_description: string;
  state: string;
  city: string;
  blocked: boolean;
}

export default function BlockButton({
  id,
  updateEvents,
  expositor,
}: {
  id: number;
  updateEvents: Function;
  expositor: Expositor;
}) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const { showToast } = useToast();
  const [open, setOpen] = React.useState(false);
  const [blocked, setBlocked] = React.useState(expositor.blocked);

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const handleSubmit = () =>
    updateBlock(blocked, expositor.id).then(() => {
      showToast(blocked ? "Acesso do expositor bloqueado!" : "Acesso do expositor liberado!", { severity: "success" });
      handleClose();
      updateEvents();
    });

  return (
    <>
      <ModalComponent
        open={open}
        handleClose={handleClose}
        title={blocked ? "Bloquear Acesso" : "Liberar Acesso"}
        maxWidth={isMobile ? "90%" : 600}
        autoHeight
      >
        <Box>
          <Typography variant="body2" color="text.secondary" gutterBottom>
            Usuário: {expositor?.name} ({expositor?.brand_name})
          </Typography>
          <Typography variant="subtitle1" sx={{ mb: 2, color: "#24324D" }}>
            {blocked
              ? "Deseja bloquear o acesso deste expositor à plataforma?"
              : "Deseja liberar o acesso deste expositor à plataforma?"}
          </Typography>

          <FormControl fullWidth size={isMobile ? "small" : "medium"}>
            <InputLabel id="block-select-label">Estado</InputLabel>
            <Select
              labelId="block-select-label"
              id="block-select"
              value={blocked ? 1 : 0}
              label="Estado"
              onChange={(e) => {
                const val = Number(e.target.value);
                setBlocked(Boolean(val));
              }}
            >
              <MenuItem value={0}>Liberado</MenuItem>
              <MenuItem value={1}>Bloqueado</MenuItem>
            </Select>
          </FormControl>
        </Box>

        <Box
          sx={{
            display: "flex",
            gap: 2,
            flexDirection: isMobile ? "column" : "row-reverse",
            justifyContent: isMobile ? "flex-end" : "flex-start",
            borderTop: "1px solid",
            borderColor: "divider",
            p: 2,
          }}
        >
          <Button
            variant="contained"
            onClick={handleSubmit}
            sx={adminButtonPrimarySx}
            fullWidth={isMobile}
          >
            Alterar
          </Button>
          <Button
            onClick={handleClose}
            sx={adminButtonOutlinedSx}
            fullWidth={isMobile}
          >
            Cancelar
          </Button>
        </Box>
      </ModalComponent>
      <IconButton
        title="Bloquear/Liberar acesso"
        color={expositor.blocked ? "error" : "default"}
        size={isMobile ? "small" : "medium"}
        onClick={handleOpen}
      >
        <DoNotDisturbIcon />
      </IconButton>
    </>
  );
}
